// removed by extract-text-webpack-plugin
module.exports = {"table":"_1BX3m4HhDEcnCYkWsWgePL","ieStyleRule":"_1XDssJpk4nMqxSX2p6v9Tn","cell":"PuFeF66W1e-rcMyVW0KHh","headerCell":"l6LqgguvbWLqZAsjZQPs0","activeText":"_1YHMA7s81I2DW3-rfaHmgn","center":"_30pQE3qBW1vnZjZ1xM1C4P","noMeds":"LboBxObGrugiLFk9EO9HX","bodyCell":"_10nN-nxzdsa_WxaaKOg-vi","bold":"_1HVm7RvqYRm10uriCFMivc","hideMobile":"_3yg1EdhrLfxz7vHt3Wcgk9","checkmark":"_2RH5wZNuZ5CaEQ8sz7tnxu","borderBottom":"_2Hd1N92YtpmSSi7xB-ZA2_","btn":"_39Bxfftcdtga0JNxRwFm1z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/MedicationsList/MedicationsList.css
// module id = 1303
// module chunks = 0